import styles from "./searchInput.module.scss";
import { useTranslation } from "react-i18next";
import { ChangeEvent } from "react";
import searchIcon from "../../images/search.svg";

type InputProps = {
  disabled?: boolean;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export const SearchInput = ({ disabled, placeholder, onChange, value }: InputProps) => {
  const { t } = useTranslation();

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={styles.container}>
      <input type="text"
             onChange={onInputChange}
             value={value}
             placeholder={placeholder || t("common.search")}
             autoComplete="off"
             disabled={disabled}/>
      <img src={searchIcon} alt=""/>
    </div>
  )
}
